import React from "react";
import styled from "styled-components";

export default styled.h2`
    font-size: 32px;
    line-height: 38px;
    font-weight: 700;
    color: #5562C0;
`;